// Product pages (classic.html / pro.html)

// gallery thumbs
const ppMain = document.getElementById('ppMain');
document.querySelectorAll('.pp-thumbs .th[data-src]').forEach(t => t.addEventListener('click', () => {
  document.querySelectorAll('.pp-thumbs .th').forEach(x => x.classList.remove('active'));
  t.classList.add('active');
  ppMain.src = t.dataset.src;
  ppMain.alt = t.dataset.alt;
}));

// delivery estimate: ordered today, ready next business day, delivered in min–max business days
(function () {
  const box = document.getElementById('shipEst');
  if (!box) return;
  const fmt = d => d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  const addBiz = (d, n) => { const x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() % 6) n--; } return x; };
  const today = new Date();
  const ready = addBiz(today, 1);
  box.querySelector('[data-d="0"]').textContent = fmt(today);
  box.querySelector('[data-d="1"]').textContent = fmt(ready);
  box.querySelector('[data-range]').textContent = fmt(addBiz(ready, +box.dataset.min)) + ' – ' + fmt(addBiz(ready, +box.dataset.max));
})();

// sticky mobile buy bar (price + Add to Cart) whenever the real Add to Cart button is off screen
const cta = document.querySelector('.pp-cta'), bar = document.getElementById('stickyBuy');
function syncBar() {
  const r = cta.getBoundingClientRect();
  bar.classList.toggle('show', r.bottom < 0 || r.top > innerHeight);
}
if (cta && bar) {
  syncBar();
  addEventListener('scroll', syncBar, { passive: true });
  addEventListener('resize', syncBar);
  addEventListener('load', syncBar);
}

// interactive massage styles (Pro page)
(function () {
  const viz = document.getElementById('msViz');
  if (!viz) return;
  const cap = document.getElementById('msCap'), badge = document.getElementById('msBadge');
  const btns = [...document.querySelectorAll('.mbtn')];
  const seq = ['tapping', 'rolling', 'deep', 'kneading'], label = { tapping: 'ACUPUNCTURE-STYLE', rolling: 'TUINA', deep: 'FINGER-PRESS', kneading: 'KNEADING' };
  let timer = null, idx = 0;
  const show = m => { viz.classList.remove('m-tapping', 'm-rolling', 'm-deep', 'm-kneading'); void viz.offsetWidth; viz.classList.add('m-' + m); };
  function select(b) {
    btns.forEach(x => { x.classList.toggle('on', x === b); x.setAttribute('aria-selected', x === b); });
    const sub = b.querySelector('div > span');
    cap.innerHTML = b.querySelector('b').textContent + (sub ? '<small>' + sub.textContent + '</small>' : '');
    clearInterval(timer);
    const m = b.dataset.m;
    if (m === 'auto') {
      const step = () => { show(seq[idx]); badge.textContent = 'AUTO · ' + label[seq[idx]]; };
      step(); timer = setInterval(() => { idx = (idx + 1) % seq.length; step(); }, 3200);
    } else { badge.textContent = b.dataset.label || label[m]; show(m); }
  }
  btns.forEach(b => b.addEventListener('click', () => select(b)));
  select(btns[0]);
})();

// thumbnail column arrows (only rendered when there are more than 7 slots)
(() => {
  const tb = document.querySelector('.pp-thumbs'), up = document.querySelector('.th-nav.up'), dn = document.querySelector('.th-nav.down');
  if (!tb || !dn) return;
  const step = () => (tb.querySelector('.th').offsetHeight + 8) * 2;
  const sync = () => {
    up.classList.toggle('off', tb.scrollTop < 4);
    dn.classList.toggle('off', tb.scrollTop + tb.clientHeight >= tb.scrollHeight - 4);
  };
  dn.addEventListener('click', () => tb.scrollBy({ top: step(), behavior: 'smooth' }));
  up.addEventListener('click', () => tb.scrollBy({ top: -step(), behavior: 'smooth' }));
  tb.addEventListener('scroll', sync, { passive: true });
  addEventListener('resize', sync);
  sync();
})();

// Classic reviews carousel: arrows + dots, one "page" = what fits in view
(() => {
  const tr = document.getElementById('rv2Track'), dots = document.getElementById('rv2Dots');
  if (!tr || tr.classList.contains('loop')) return;
  const prev = document.querySelector('.rv2-arr.prev'), next = document.querySelector('.rv2-arr.next');
  const pages = () => Math.max(1, Math.round(tr.scrollWidth / tr.clientWidth));
  const cur = () => Math.round(tr.scrollLeft / tr.clientWidth);
  const draw = () => {
    const n = pages(), c = Math.min(cur(), n - 1);
    if (dots.children.length !== n) {
      dots.innerHTML = '';
      for (let i = 0; i < n; i++) { const d = document.createElement('i'); d.addEventListener('click', () => tr.scrollTo({ left: i * tr.clientWidth })); dots.appendChild(d); }
    }
    [...dots.children].forEach((d, i) => d.classList.toggle('on', i === c));
    prev.disabled = tr.scrollLeft < 4;
    next.disabled = tr.scrollLeft + tr.clientWidth >= tr.scrollWidth - 4;
  };
  prev.addEventListener('click', () => tr.scrollBy({ left: -tr.clientWidth }));
  next.addEventListener('click', () => tr.scrollBy({ left: tr.clientWidth }));
  tr.addEventListener('scroll', draw, { passive: true });
  addEventListener('resize', draw);
  draw();
})();

// Classic reviews: endless loop — 3 in view (1 on phones), arrows step one review, never hits an end
(() => {
  const tr = document.querySelector('#rv2Track.loop'), dots = document.getElementById('rv2Dots');
  if (!tr) return;
  const prev = document.querySelector('.rv2-arr.prev'), next = document.querySelector('.rv2-arr.next');
  const n = tr.children.length;
  [...tr.children].forEach((el, i) => el.dataset.i = i);
  let busy = false;
  const w = () => tr.firstElementChild.getBoundingClientRect().width;
  const paint = () => { const c = +tr.firstElementChild.dataset.i; [...dots.children].forEach((d, i) => d.classList.toggle('on', i === c)); };
  const go = dir => {
    if (busy) return; busy = true;
    // finish on transitionend, or after the duration anyway (background tabs / reduced motion never fire it)
    const done = fn => { let ok = false; const f = () => { if (ok) return; ok = true; fn(); busy = false; paint(); }; tr.addEventListener('transitionend', f, { once: true }); setTimeout(f, 660); };
    // one click = one full view (3 on desktop, 1 on phones)
    const k = Math.max(1, Math.round(tr.parentElement.clientWidth / w()));
    if (dir > 0) {
      tr.style.transition = 'transform .6s ease'; tr.style.transform = `translateX(${-w() * k}px)`;
      done(() => { tr.style.transition = 'none'; for (let i = 0; i < k; i++) tr.appendChild(tr.firstElementChild); tr.style.transform = 'none'; });
    } else {
      tr.style.transition = 'none'; for (let i = 0; i < k; i++) tr.prepend(tr.lastElementChild); tr.style.transform = `translateX(${-w() * k}px)`;
      void tr.offsetWidth;
      tr.style.transition = 'transform .6s ease'; tr.style.transform = 'none';
      done(() => {});
    }
  };
  for (let i = 0; i < n; i++) {
    const d = document.createElement('i');
    d.addEventListener('click', () => { while (+tr.firstElementChild.dataset.i !== i) tr.appendChild(tr.firstElementChild); paint(); });
    dots.appendChild(d);
  }
  prev.addEventListener('click', () => go(-1));
  next.addEventListener('click', () => go(1));
  let x0 = null;
  tr.addEventListener('pointerdown', e => { x0 = e.clientX; });
  tr.addEventListener('pointerup', e => { if (x0 !== null && Math.abs(e.clientX - x0) > 40) go(e.clientX < x0 ? 1 : -1); x0 = null; });
  paint();
})();
